import Vue from 'vue'
import Router from 'vue-router'
const Index = r => require.ensure([], () => r(require('../view/index/Index')), 'Index')

const Requirement = r => require.ensure([], () => r(require('../view/requirement/Requirement')), 'Requirement')
const Recommend = r => require.ensure([], () => r(require('../view/recommend/Recommend')), 'Recommend')
const Issue = r => require.ensure([], () => r(require('../view/issue/Issue')), 'Issue')
const Consult = r => require.ensure([], () => r(require('../view/consult/Consult')), 'Consult')

const category = r => require.ensure([], () => r(require('../view/consult/category')), 'category')//产品分类
const category2 = r => require.ensure([], () => r(require('../view/consult/category2')), 'category2')//产品分类
const newcategory2 = r => require.ensure([], () => r(require('../view/consult/newcategory2')), 'newcategory2')//产品分类
const newcategory3 = r => require.ensure([], () => r(require('../view/consult/newcategory3')), 'newcategory3')//产品分类
const ContactUs = r => require.ensure([], () => r(require('../view/consult/ContactUs')), 'ContactUs')// 联系销售

const download = r => require.ensure([], () => r(require('../view/consult/download')), 'download')//微信浏览器引导下载
const video = r => require.ensure([], () => r(require('../view/consult/video')), 'video')
const evmpermit = r => require.ensure([], () => r(require('../view/evmpermit/evmpermit')), 'evmpermit')
const evmpermitOrder = r => require.ensure([], () => r(require('../view/evmpermit/evmpermitOrder')), 'evmpermitOrder')
const evmpermitsubmitOrders = r => require.ensure([], () => r(require('../view/evmpermit/evmpermitsubmitOrders')), 'evmpermitsubmitOrders')
const HWKnow = r => require.ensure([], () => r(require('../view/hazardousWaste/HWKnow')), 'HWKnow')
const wasteDisposal = r => require.ensure([], () => r(require('../view/wasteDisposal/wasteDisposal')), 'wasteDisposal')
const Personal = r => require.ensure([], () => r(require('../view/personal/personal')), 'Personal')
const myRequirement = r => require.ensure([], () => r(require('../view/personal/children/myRequirement')), 'myRequirement')
const submitOrders = r => require.ensure([], () => r(require('../components/submitOrders')), 'submitOrders')
const myRqDetail = r => require.ensure([], () => r(require('../view/personal/children/myRqDetail')), 'myRqDetail')
const IMSystem = r => require.ensure([], () => r(require('../view/personal/children/IMSystem')), 'IMSystem')
const IMWindow = r => require.ensure([], () => r(require('../view/personal/children/IMWindow')), 'IMWindow')
const Login = r => require.ensure([], () => r(require('../view/login/login')), 'Login')
const Login_dynamic = r => require.ensure([], () => r(require('../view/login/login_dynamic')), 'Login_dynamic')
const Register = r => require.ensure([], () => r(require('../view/login/register')), 'Register')
const Password = r => require.ensure([], () => r(require('../view/login/password')), 'Password')
const construction = r => require.ensure([], () => r(require('../view/construction/construction')), 'construction')
const MyOrder = r => require.ensure([], () => r(require('../view/personal/children/myOrder')), 'MyOrder')
const orderDetail = r => require.ensure([], () => r(require('../view/personal/children/orderDetail')), 'orderDetail')
const pay = r => require.ensure([], () => r(require('../view/pay/pay')), 'pay')
const temp = r => require.ensure([], () => r(require('../view/temp/temp')), 'temp')
const temp2 = r => require.ensure([], () => r(require('../view/temp/temp2')), 'temp2')
const complaindetail = r => require.ensure([], () => r(require('../view/temp/complaindetail')), 'complaindetail')
const authList = r => require.ensure([], () => r(require('../view/authCustomer/authList')), 'authList')
const playvideo = r => require.ensure([], () => r(require('../view/consult/playvideo')), 'playvideo')
const picture = r => require.ensure([], () => r(require('../view/consult/picture')), 'picture')
const pdf2 = r => require.ensure([], () => r(require('../view/consult/pdf2')), 'pdf2')
const knowledgedetail = r => require.ensure([], () => r(require('../view/recommend/knowledgedetail')), 'knowledgedetail')
const productDetail = r => require.ensure([], () => r(require('../view/consult/productDetail')), 'productDetail')
const testnew = r => require.ensure([], () => r(require('../view/consult/testnew')), 'testnew')
const complainsuccsess = r => require.ensure([], () => r(require('../view/temp/complainsuccsess')), 'complainsuccsess')
const videoCategory = r => require.ensure([], () => r(require('../view/consult/videoCategory')), 'videoCategory')
const authListInfo = r => require.ensure([], () => r(require('../view/authCustomer/authListInfo')), 'authListInfo')
const noinfo = r => require.ensure([], () => r(require('../view/noinfo/noinfo')), 'noinfo')//正在更新中...
Vue.use(Router)


const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/complainsuccsess',
      name: 'complainsuccsess',
      component: complainsuccsess
    },
    {
      path: '/testnew', // 授权经销商列表
      name: 'testnew',
      component: testnew
    },
    {
      path: '/Requirement', // 环保需求
      name: 'Requirement',
      component: Requirement
    },
    {
      path: '/Recommend', // 优质推荐
      name: 'Recommend',
      component: Recommend
    },
    {
      path: '/Issue', // 发布需求
      name: 'Issue',
      component: Issue
    },
    {
      path: '/Consult', // 环保资讯
      name: 'Consult',
      component: Consult
    },
    {
      path: '/category', // 分类
      name: 'category',
      component: category
    },
    {
      path: '/category2', // 分类
      name: 'category2',
      component: category2
    },
    {
      path: '/newcategory2', // 分类
      name: 'newcategory2',
      component: newcategory2,

    },
    {
      path: '/newcategory3', // 分类
      name: 'newcategory3',
      component: newcategory3
    },
    {
      path: '/download', // 环保资讯
      name: 'download',
      meta: { title: "纽勤文件下载" },
      component: download
    },
    {
      path: '/video', // 环保资讯
      name: 'video',
      component: video
    },
    {
      path: '/evmpermit', // 排污许可证
      name: 'evmpermit',
      component: evmpermit
    },
    {
      path: '/evmpermitOrder', // 排污许可证提交订单
      name: 'evmpermitOrder',
      component: evmpermitOrder
    },
    {
      path: '/evmpermitsubmitOrders', // 排污许可证提交订单个人信息
      name: 'evmpermitsubmitOrders',
      component: evmpermitsubmitOrders
    },
    {
      path: '/HWKnow', // 危废须知
      name: 'HWKnow',
      component: HWKnow
    },
    {
      path: '/wasteDisposal', // 危废须知
      name: 'wasteDisposal',
      component: wasteDisposal
    },
    {
      path: '/submitOrders', // 危废须知
      name: 'submitOrders',
      component: submitOrders
    },
    {
      path: '/Personal', // 个人页面
      name: 'Personal',
      component: Personal,

    },
    {
      path: '/myRequirement/:sort', // 需求列表页面
      name: 'myRequirement',
      component: myRequirement
    },
    {
      path: '/myRqDetail/:self', // 需求详情页面
      name: 'myRqDetail',
      component: myRqDetail
    },
    {
      path: '/IMSystem', // 需求详情页面
      name: 'IMSystem',
      component: IMSystem
    },
    {
      path: '/Login', // 登录页面
      name: 'Login',
      component: Login
    },
    {
      path: '/Login_dynamic', // 动态密码登录页面
      name: 'Login_dynamic',
      component: Login_dynamic
    },
    {
      path: '/Register', // 注册页面
      name: 'Register',
      component: Register
    },
    {
      path: '/Password', // 找回密码页面
      name: 'Password',
      component: Password
    },
    {
      path: '/construction/:type', // 环保工程
      name: 'construction',
      component: construction
    },
    {
      path: '/MyOrder', // 我的订单页面
      name: 'MyOrder',
      component: MyOrder
    },
    {
      path: '/orderDetail', // 订单详情页面
      name: 'orderDetail',
      component: orderDetail
    },
    {
      path: '/pay', // 订单支付
      name: 'pay',
      component: pay
    },
    {
      path: '/temp', // 投诉页面
      name: 'temp',
      component: temp
    },
    {
      path: '/temp2', // 投诉页面
      name: 'temp2',
      component: temp2
    },
    {
      path: '/complaindetail', // 投诉页面
      name: 'complaindetail',
      component: complaindetail
    },
    {
      path: '/authList', // 授权经销商列表
      name: 'authList',
      component: authList
    },
    {
      path: '/playvideo', // 授权经销商列表
      name: 'playvideo',
      component: playvideo
    },
    {
      path: '/ContactUs', // 授权经销商列表
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/knowledgedetail', // 授权经销商列表
      name: 'knowledgedetail',
      component: knowledgedetail
    },
    {
      path: '/productDetail', // 授权经销商列表
      name: 'productDetail',
      component: productDetail
    },
    {
      path: '/videoCategory', // 授权经销商列表
      name: 'videoCategory',
      component: videoCategory
    },
    {
      path: '/auth', // 授权经销商列表
      name: 'auth',
      component: authListInfo
    },
    {
      path: '/noinfo', // 正在更新中...
      name: 'noinfo',
      component: noinfo
    }
    ,
    {
      path: '/picture', // 正在更新中...
      name: 'picture',
      component: picture
    },
    {
      path: '/pdf2', // 正在更新中...
      name: 'pdf2',
      component: pdf2
    }
  ]
})

// so easy
router.beforeEach(function (to, from, next) {
  // loading 相关
  // Vue.$vux.confirm.hide()
  // Vue.$vux.toast.hide()
  const agent = navigator.userAgent
  const isiOS = !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  // XXX: 修复iOS版微信HTML5 History兼容性问题
  console.log(to.path)
  console.log(to.fullPath + "-------")
  // if(to.path.indexOf("Personal") != -1){

  //   next()
  // }
  if (isiOS && to.path !== location.pathname) {

    // 此处不可使用location.replace
    location.assign(to.fullPath)
  } else {
    if (to.meta.title) {//如果设置标题，拦截后设置标题
      document.title = to.meta.title
    }
    next()
  }
})


export default router;



// WEBPACK FOOTER //
// ./src/router/index.js